var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgReceivedVoicemail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#FEECEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 12c-3.04 0-5.5 2.46-5.5 5.5 0 1.33.47 2.55 1.26 3.5h-4.52c.79-.95 1.26-2.17 1.26-3.5 0-3.04-2.46-5.5-5.5-5.5S6 14.46 6 17.5 8.46 23 11.5 23h13c3.04 0 5.5-2.46 5.5-5.5S27.54 12 24.5 12zm-13 9C9.57 21 8 19.43 8 17.5S9.57 14 11.5 14s3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5zm13 0c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z",
    fill: "#F44336"
  })));
}

export default __webpack_public_path__ + "fb2f00a2e306ca4353b2a5b10e77593f.svg";
export { SvgReceivedVoicemail as ReactComponent };